<!--
 * @Deccription:
 * @Author: zjg
 * @Date: 2020-02-18 14:21:56
 * @LastEditTime: 2020-03-14 18:28:01
 -->
<template>
  <bs-auth
    v-if="isAuth"
    :data="data"
    @authToken="authToken"
  />
  <!-- 外链smartshare文件 -->
  <div
    v-else
    class="link-box"
    style="width: 100%; height: 100%"
  >
    <!--外链下载 iframe-->
    <iframe
      id="download-iframe"
      src="javascript:false;"
      width="0"
      heigth="0"
      border="none"
      style="display:none"
    />
    <!-- 容器整体的部局 bs-structure组件的prop请仔细哦-->
    <bs-structure
      :display-right="displayRightPanel"
      :is-full-screen="isFullScreen"
      :box-margin-r="20"
      :box-margin-l="20"
    >
      <!-- header -->
      <template slot="boxHeader">
        <bs-header>
          <div class="fl-r lh-50">
            <bs-reply :data="data" />
            <co-button
              v-if="topBtnPower.showDown"
              self-class="s-btn"
              @click="downFile"
            >
              {{ $t('下载') }}
            </co-button><!--
                        --><bs-qrcode /><!--
                        --><co-button
self-class="right-pannel c-btn"
@click="toggleRightColumn"
>
                            <template name="default">
                                <svg class="right-pannel-icon">
                                    <use :xlink:href="displayRightPanel ? '#retractRightcolumn' : abnormalType==='noAccess'? '#disExpendRightcolumn':'#expendRightcolumn'" />
                                </svg>
                            </template>
                        </co-button>
          </div>
        </bs-header>
      </template>
      <!-- body -->
      <template slot="boxBody">
        <div
          class="link-box-body"
          @mousemove="footMouseMove"
        >
          <!--上部预览-->
          <div
            class="link-box-main"
            :style="{height:isShowFoot?'calc(100% - 50px)':'100%'}"
          >
            <!-- 正常预览 -->
            <bs-switch
              v-if="!abnormalType"
              ref="bsswitch"
              :is-delivery="true"
              @iframeloaded="iframeloaded"
              @loadFail="loadFail"
            />
            <!-- 异常预览提示 -->
            <bs-abnormal
              v-else
              :data="metaData"
              :type="abnormalType"
              :abnormal-data="abnormalData"
              @abnormal="abnormal"
            />
          </div>
          <!--下部底部栏-->
          <div
            v-show="isShowFoot"
            class="link-box-footer"
          >
            <bs-PdftoolBar
              ref="pdftoolbar"
              :is-smart-share="true"
              :data="metaData"
              :doc-check="docCheck"
              @pagechange="pagechange"
              @pagesCount="pagesCount"
              @presentationMode="presentationMode"
            />
          </div>
        </div>
      </template>
      <template slot="boxRight">
        <!--right panel-->
        <div
          v-show="displayRightPanel"
          class="link-right"
        >
          <bsLinkRight :data="metaData" />
        </div>
      </template>
    </bs-structure>
    <!-- <bs-reply></bs-reply> -->
  </div>
</template>
<script>
import { getAuthToken } from 'components/business/link/auth/fiveMinAuth.js'
import _$ from 'js/api/getdata.js'
import bsStructure from 'components/business/structure/index.vue'
import bsLinkRight from 'components/business/link/linkright/index.vue'
import bsReply from 'components/business/link/reply/index.vue'
import bsHeader from 'components/business/link/header/index.vue'
import bsSwitch from 'components/business/switch/index.vue'
import bsAbnormal from 'components/business/abnormal/index.vue'
import bsPdftoolBar from 'components/business/pdftoolbar/index.vue'
import bsAuth from 'components/business/link/auth/index.vue' // 外链提取码页面
import bsQrcode from 'components/business/qrcode/index.vue'
import { isExcel, resolveFileAction, formatDate } from 'js/util/util'
import coButton from 'components/common/button/index.vue'
import SmartshareFeedback from 'js/preview/smartshare-feedback.js'
import { linkDownLoad } from 'js/api/download/linkDown.js'
import { PREVIEW } from 'js/mixin/common.js'
import { LINKFILE } from 'js/mixin/linkcommon.js'

export default {
  components: {
    bsStructure,
    bsLinkRight,
    bsHeader,
    bsSwitch,
    bsAbnormal,
    bsPdftoolBar,
    bsAuth,
    bsQrcode,
    coButton,
    bsReply,
  },
  /**
         * 主要混入的函数
         * showFoot
         * footMouseMove
         * LINKFILE中:
         * linkPreviewLimit
         * accountSupport
         * nonTrialAccount
         * typeSupport
         * checkPreSupport
         * showAbornomal
         * sendRecent
         */
  mixins: [PREVIEW, LINKFILE],
  props: {
    data: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      isAuth: false, // 是否要输入提取码
      metaData: {}, // 数据信息
      displayRightPanel: true, // 默认展开右侧栏
      abnormalType: '', // 异常类型
      isShowFoot: true, // 是否显示底部栏
      currentPage: 1,
      totalPage: 1,
      oldPage: 1,
      SmartshareFeedbackClass: null,
      authData: {}, // 预览所需的验证参数
      topBtnPower: {
        showDown: false, // 显示下载按钮
      },
      // 链接数据
      shareInfo: {
        isSecurity: false, // 安全外链
        isApprove: false, // 审批外链
        isTrial: false, // 体验用户
      },
      abnormalData: {}, // 异常需要的额外数据
    }
  },
  watch: {
    data: {
      handler(n) {
        // this.shareInfo.isSecurity = n.ext.linkInfo.security != 0
        // this.shareInfo.isApprove = n.ext.linkInfo.approval != 0
        // 处理其他逻辑
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.init()
  },
  mounted() {
    window.addEventListener('message', this.viewError, false)
  },
  destroyed() {
    window.removeEventListener('message', this.viewError)
  },
  beforeDestroy() {
    if (this.SmartshareFeedbackClass) {
      this.SmartshareFeedbackClass.clean()
    }
  },
  methods: {
    /**
             * 设置顶部按钮显示的方法
             */
    getTopBtnShow(data) {
      const power = resolveFileAction(data.access_mode)
      // 含有下载权限，并且该文件不是apk类型的文件
      if (/download/.test(power) && !/\.apk$/.test(data.mime_type)) {
        this.topBtnPower.showDown = true
      }
    },
    /**
             * 初始化
             * @param {Object} paramData为getmetadata的参数中的token
             */
    async init(paramData) {
      const params = paramData || {} // getMetaData的参数
      const tokenRes = getAuthToken(this.data.deliverycode) // 5分中内的判断
      this.data.ext.emailOrMobile = tokenRes.emobile || '' // 给props的data添加参数，用于reply的显示
      this.authData.folder_id = tokenRes.folder_id || this.data.deliverycode
      this.authData.password = tokenRes.password || ''
      this.authData.token = tokenRes.token || ''
      // 判断是否需要输入提取码 or 是否需要sm验证
      if (this.data.ext.protected || (this.data.ext.is_smartshare && this.data.ext.receiver_setting != 0)) {
        if (!params.token) { // 是否已有验证获取的token
          if (!tokenRes.hasToken) {
            this.isAuth = true
            return
          }
          params.token = tokenRes.token
        }
      }
      let data = {}
      try {
        data = await this.getMetaData(this.data.deliverycode, params)
      } catch (e) {
        console.log('here some error happens', e)
        const error = (e.response && e.response.data) || {}
        const state = error.state || '403'
        if (state == '403') {
          this.isAuth = true
          return
        }
        const errCfg = {
          404: { type: 'invalidLose' }, // 已失效
          500: { type: 'loadFail' }, // 加载失败
        }
        this.isAuth = false
        this.abnormalType = errCfg[state].type
        this.metaData = {}
        this.displayRightPanel = false // 不显示右侧栏
        this.isShowFoot = false // 不显示底部栏
        return
      }
      this.isAuth = false
      this.metaData = Object.assign(data, this.authData)
      this.metaData.delivery_ad = (this.data.ext && this.data.ext.deliveryAd) == '1' || false // 合并data（delivery/actionView获取）到metaData（delivery/metadata获取）
      this.shareInfo.isTrial = this.metaData.is_trial // 是否是体验版
      const ctime = (this.data.ext.linkInfo && this.data.ext.linkInfo.ctime).toString() || ''
      const deliveryInfo = { // 外链文件最近访问信息
        deliverycreator: this.metaData.delivery_creator,
        deliveryfilename: this.metaData.path ? this.metaData.path.substring(1) : '',
        delivery_ctime: ctime.substring(0, 16),
        expiration: formatDate(this.metaData.expiration, 'yyyy-MM-dd hh:mm'),
        deliverydescription: this.metaData.delivery_desc,
        deliveryId: this.data.deliverycode,
      }
      this.sendRecent(deliveryInfo) // 最近访问
      // 是否支持预览（权限，大小，体验版，类型等）
      const preSupport = await this.checkPreSupport() || {}
      if (preSupport.canPreview) { // 正常预览
        this.getTopBtnShow(this.metaData) // 头部按钮如何显示
        this.abnormalType = '' // 可以预览时，不显示异常
        this.checkMimeType() // 通过文件类型判断 是否显示底部栏
        this.$nextTick(() => {
          this.$refs.bsswitch.startPreview(this.metaData) // 开始预览
        })
        return
      }
      // 异常
      this.showAbornomal(preSupport)
      this.isShowFoot = false // 异常时，不显示底部栏
    },
    /**
             * 获取外链文件信息
             */
    async getMetaData(neid, params) {
      const url = `/v2/delivery/metadata/${neid}`
      let d = await _$.getData(url, params)
      d = d.data
      return d
    },
    /**
             * 验证组件验证通过后，emit的事件
             */
    async authToken(data) {
      const params = {
        token: data.token,
      }
      this.init(params) // token验证
    },
    iframeloaded() {
      this.SmartshareFeedbackClass = new SmartshareFeedback(this.metaData, this.data)
      if (this.SmartshareFeedbackClass) {
        this.SmartshareFeedbackClass.init()
        // 这里监听关闭网页的方法
        this.SmartshareFeedbackClass.onbeforeunload()
      }
    },
    /**
             * 验证文件类型是否支持底部栏操作，不支持时影响底部栏
             * 目前是excel和幻灯片模式 一类的文件走owa，在外链里没有底部栏
             * 由于sm中没有幻灯片模式，所以不需要判断 幻灯片
             */
    checkMimeType() {
      if (this.abnormalType) return
      const type = this.metaData.mime_type
      if (isExcel(type)) {
        this.isShowFoot = false
        return
      }
      this.isShowFoot = true
    },
    /**
             * toggle 右侧栏
             */
    toggleRightColumn() {
      this.displayRightPanel = !this.displayRightPanel
    },
    /**
             * 异常函数的操作事件
             */
    abnormal(key) {
      const cfg = {
        download: 'downFile', // download
        refresh: 'init', // refresh
      }
      if (cfg[key]) {
        this[cfg[key]]()
      }
    },
    /**
             * 校验doc档预览
             * 超过文件限制，或者幻灯片模式是否要预览
             */
    docCheck() {
      if (!this.metaData) {
        return false
      }
      return !isExcel(this.metaData.mime_type) && this.abnormalType != 'oversize'
    },
    /**
             * pdfjs 对页数变化的callback
             */
    pagechange(param) {
      this.currentPage = param && param.cpage
      this.totalPage = param && param.tpage
      this.oldPage = param && param.opage
      if (this.totalPage !== 0 && this.SmartshareFeedbackClass) {
        this.SmartshareFeedbackClass.changePage({
          currentPage: this.currentPage,
          totalPage: this.totalPage,
          oldPage: this.oldPage,
        })
      }
    },
    /**
             * pdfjs 总页数变化
             */
    pagesCount(param) {
      if (this.SmartshareFeedbackClass) {
        this.SmartshareFeedbackClass.pagesCount(param)
      }
    },
    downFile() {
      if (Object.keys(this.metaData).length < 1) {
        // 弹窗提示警告信息
        this.$toast.simpleShow('目标文件禁止此操作', 'warn')
        return
      }
      if (this.shareInfo.isTrial) {
        // 弹窗提示警告信息
        this.$toast.simpleShow('体验版本不支持下载，请升级版本', 'warn')
        return
      }
      // 下载数据
      linkDownLoad(this.shareInfo, [this.metaData], true, () => {})
      if (this.SmartshareFeedbackClass) {
        this.SmartshareFeedbackClass.download()
      }
    },
    /**
             * 异常报错
             */
    viewError(e) {
      if (e && e.data === 'pdfLoadError') { // 监听到pdf报错信息，调用异常组件
        this.abnormalType = 'loadFail'
      }
    },
  },
}
</script>
<style lang="less" scoped>
@import '~less/link.less';
.link-box {
  .link-box-body{
    position: absolute;
  }
  .lh-50{
    .right-pannel{
      min-width: 32px;
      padding: 0;
      .right-pannel-icon{
        width: 24px;
        height: 24px;
        vertical-align: -6px;
        display: inline-block;
      }
    }
  }
}
</style>
